import {Button, Card, Select, Tabs, Tooltip, Typography} from "antd";
import {ReloadOutlined, UserAddOutlined} from "@ant-design/icons";
import {DataGridProvider} from "../components/data-grid/DataGridContext";
import AdminCheckHistory from "../app-components/admin-dashboard/CheckHistoryGrid/AdminCheckHistory";
import AdminCompareHistory from "../app-components/admin-dashboard/CompareHistoryGrid/AdminCompareHistory";
import AdminUserDashboardGrid from "../app-components/admin-dashboard/UserGrid/AdminUserDashboardGrid";
import {useEffect, useState} from "react";
import ApiService from "../services/ApiService";
import AdminUserGrid from "../app-components/admin-dashboard/UserGrid/AdminUserGrid";
import AccessControlGrid from "../app-components/admin-dashboard/AccessControl/AccessControlGrid";
import CreateUserModal from "../app-components/admin-dashboard/AccessControl/CreateUserModal";
import MapAssetsTab from "../app-components/admin-dashboard/MapAssets/MapAssetsTab";

export default function AdminDashboard() {
    const [users, setUsers] = useState([])
    const [userId, setUserId] = useState(null)
    const [createModalVisible, setCreateModalVisible] = useState(false)
    const [refreshKey, setRefreshKey] = useState(0)
    const [refreshing, setRefreshing] = useState(false)

    const getUsers = async () => {
        const res = await ApiService.AdminDashboard.GetUserList();
        if(res) {
            setUsers(res.data)
        }
    }

    useEffect(() => {
        getUsers()
    }, [])

    const refreshAll = async () => {
        setRefreshing(true)
        try {
            await getUsers()
            setRefreshKey((k) => k + 1)
        } finally {
            setRefreshing(false)
        }
    }

    return (
        <>
            <Card title={'Admin Dashboard'}>
                <div style={{display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16}}>
                    <Typography.Text>
                        Users:
                    </Typography.Text>
                    <Button
                        type={'primary'}
                        icon={<UserAddOutlined/>}
                        onClick={() => setCreateModalVisible(true)}
                    >
                        Create User
                    </Button>
                    <Select
                        placeholder={'Select User'}
                        style={{width: 300}}
                        options={users}
                        value={userId || undefined}
                        onSelect={(value) => setUserId(value)}
                        filterOption={(inputValue, option) => {
                            return option.email.includes(inputValue.toLocaleLowerCase())
                        }}
                        showSearch={true}
                        onClear={() => setUserId(null)}
                        allowClear={true}
                        fieldNames={{
                            label: 'email',
                            value: 'id'
                        }}
                    />
                    <Tooltip title={'Refresh'}>
                        <Button
                            icon={<ReloadOutlined/>}
                            loading={refreshing}
                            onClick={refreshAll}
                        />
                    </Tooltip>
                </div>
                <Tabs>
                    <Tabs.TabPane tab={'Registered Users'} key={'Registered Users'}>
                        <DataGridProvider key={`reg-${refreshKey}`}>
                            <AdminUserGrid userId={userId}/>
                        </DataGridProvider>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab={'Access Control'} key={'Access Control'}>
                        <DataGridProvider key={`acc-${refreshKey}`}>
                            <AccessControlGrid userId={userId}/>
                        </DataGridProvider>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab={'User Dashboard'} key={'Users'}>
                        <DataGridProvider key={`usr-${refreshKey}`}>
                            <AdminUserDashboardGrid userId={userId}/>
                        </DataGridProvider>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab={'Checks'} key={'Checks'}>
                        <DataGridProvider key={`chk-${refreshKey}`}>
                            <AdminCheckHistory userId={userId} />
                        </DataGridProvider>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab={'Comparisons'} key={'Comparisons'}>
                        <DataGridProvider key={`cmp-${refreshKey}`}>
                            <AdminCompareHistory userId={userId} />
                        </DataGridProvider>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab={'Map Assets'} key={'Map Assets'}>
                        <MapAssetsTab key={`map-${refreshKey}`}/>
                    </Tabs.TabPane>
                </Tabs>
            </Card>
            <CreateUserModal
                visible={createModalVisible}
                onClose={() => setCreateModalVisible(false)}
                onCreated={refreshAll}
            />
        </>
    )
}